<script>
import {defineComponent, reactive} from "vue";
import Icon from "./Icon.vue";
import {useLandingPageStore} from "../../stores/landingPage";
import ResourceDisplay from "./ResourceDisplay.vue";

export default defineComponent({
  name: "ImagePickerCard",
  components: {
    ResourceDisplay,
    Icon
  },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  emits: ['click', 'remove'],
  setup(props) {
    props = reactive(props);
    const landingStore = useLandingPageStore();

    return {
      landingStore
    };
  },

  data() {
    return {};
  },
  computed: {
    truncatedFileName() {
      const fileName = this.resource?.file_name || '';
      if (!fileName || fileName.length <= 16) return fileName;
      return fileName.slice(0, 8) + '...' + fileName.slice(-6);
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.resource);
    },

    removeImage() {
      this.$emit('remove', this.resource);
    }

  },

});
</script>

<template>
  <div
    v-if="resource"
    :key="resource?.resourceId"
    class="image-picker-container"
    @click="handleClick"
  >
    <div class="image-preview">
      <resource-display
        :resource-id="resource?.id"
      />
    </div>


    <div class="image-name">
      {{ truncatedFileName }}
    </div>
    <button
      class="remove-image-btn"
      @click.stop="removeImage"
    >
      <Icon
        icon="trash"
        class="icon-trash"
        :color="'#ff4d4d'"
        :size="'18px'"
      />
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.image-picker-container {
  @apply flex items-center border p-2 rounded-md;
  @apply gap-2 w-full mt-1 cursor-pointer;
  max-width: 300px;
}

.image-preview {
  @apply bg-gray-300 w-14 h-14 rounded-md overflow-hidden;
  border-radius: 4px;
}

.image-name {
  @apply truncate text-xs font-semibold flex-grow;
  color: #333;
}

.remove-image-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
